
import React from "react";
import Layout from "@/components/layout/Layout";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";
import { Link } from "react-router-dom";

export function UnauthorizedState() {
  return (
    <Layout>
      <div className="container py-8">
        <Card>
          <CardContent className="p-6">
            <div className="flex flex-col items-center justify-center text-center">
              <AlertCircle className="h-12 w-12 text-red-500 mb-4" />
              <h2 className="text-2xl font-bold mb-2">Not Authorized</h2>
              <p className="text-muted-foreground mb-4">
                You don't have permission to manage this nursing home. Only verified owners can access this page.
              </p>
              <Button asChild className="bg-grandpal-green-dark hover:bg-grandpal-green-darkHover">
                <Link to="/owner/dashboard">
                  Return to Dashboard
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
